import { TransformedCustomViewContainer } from "../../components/transformed_custom_view";
import { defaultConfig } from "./default_config";
import { PivotControl } from "../../constants/pivot_control_options";
import { DatePivotParams } from "../../entities/date_pivot_params";

export const POExportNoPerspectiveContainer = () => {
  return (
    <TransformedCustomViewContainer
      viewControllerConfig={{
        datasetName: "purchase_order_master",
        transformId: "po_list",
        folder: "outputs",
        title: "PO Export",
        dateHierarchyColumnFilter: { week: "week", month: "month" },
        columnHeaderMap: {
          purchase_order_week: "PO Week",
          purchase_order_month: "PO Month",
          eta_to_warehouse_week: "ETA Week",
          eta_to_warehouse_month: "ETA Month",
        },
        excludedSegmentationsFilter: [],
        measureColumnFilter: null,
        excludedFilterColumnFilter: [],
        showControls: [
          PivotControl.DateHierarchy,
          PivotControl.FilterBy,
          PivotControl.DatePeriodPicker,
          PivotControl.Download,
          PivotControl.ShowSettings,
          PivotControl.StoreAsDefault,
        ],
        paramsToTransformArgs: (
          params: DatePivotParams
        ): Record<string, any> => {
          return {
            date_field: params.dateHierarchy,
            min_date: params.minDate,
            max_date: params.maxDate,
            filters: params.filters,
          };
        },
        tableType: "flat",
      }}
      defaultConfig={defaultConfig}
    />
  );
};
